import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, OnInit, Output, Renderer2 } from '@angular/core';
import { AssetLink } from '@utils/helpers/asset-cpm-link';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
@Component({
  selector: 'ba-legal-person-success-step',
  templateUrl: './legal-person-success-step.component.html',
  styleUrls: ['./legal-person-success-step.component.scss'],
})
export class LegalPersonSuccessStepComponent extends AssetLink() implements OnInit, AfterViewInit {
  @Output() stepDone = new EventEmitter<void>();
  @HostBinding('attr.style')
  public get cssVars() {
    return `
      --icon-add-after: url(${this.asset('assets/images/icon-add.svg')});
      --next-circle-icon-after: url(${this.asset('assets/images/next-circle-icon.svg')});
      --icon-subtraction-after: url(${this.asset('assets/images/icon-subtraction.svg')});
      --previous-circle-icon-after: url(${this.asset('assets/images/previous-circle-icon.svg')});
    `;
  }

  constructor(private readonly host: ElementRef<HTMLDivElement>, private readonly renderer: Renderer2) {
    super();
  }

  ngAfterViewInit(): void {
    const coll = document.querySelectorAll(".collapsible, .collapsible-next");
    for (let i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", () => {
        let btn = coll[i] as HTMLDivElement | HTMLButtonElement;
        if (btn.classList[1] == 'collapsible') btn.classList.toggle("active-subtraction");
        else btn.classList.toggle("active-previous");
        let contents = btn.nextElementSibling! as HTMLDivElement;
        if (contents.style.maxHeight) {
          contents.style.maxHeight = '';
        } else {
          contents.style.maxHeight = contents.scrollHeight + "px";
        }
      });
    }
  }

  done() {
    this.stepDone.emit();
  }

  ngOnInit(): void {
    this.renderer.addClass(this.host.nativeElement, 'startup-info-host');
  }

  evtCopy() {

  }

  evtSeeDetail(e: Event) {
    e.preventDefault();
  }
}
